import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface EvaluateOpen {
    isOpen: boolean;
}
const initialState: EvaluateOpen = {
    isOpen: false,
};
const EvaluateOpenSlice = createSlice({
    name: 'EvaluateOpen',
    initialState,
    reducers: {
        setEvaluateOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
    },
});

export const { setEvaluateOpen } = EvaluateOpenSlice.actions;
export default EvaluateOpenSlice.reducer;
